// @ts-nocheck
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Routes} from '@angular/router';
import {NgDocPageWrapperComponent} from '@ng-doc/app';
import {NgDocPageType} from '@ng-doc/core';

const headerContent: string = `<h1 class="ngde ngde" id="installation" href="docs/getting-started/installation" headinglink="true">Installation<ng-doc-heading-anchor class="ng-doc-anchor ngde" anchor="installation"></ng-doc-heading-anchor></h1><p class="ngde ngde"></p><p class="ngde">NgDoc doesn't serve as a standalone application, but rather as a tool that can be integrated into your application to generate documentation. This means that you will need to create a new Angular application, or use an existing one, and install NgDoc as a dependency.</p><p class="ngde"></p>`

@Component({
  selector: 'ng-doc-page-wrapper-ygnr861o',
  template: `<ng-doc-page-wrapper [routes]="routes" [headerContent]="headerContent" [hasBreadcrumb]="hasBreadcrumb" [pageType]="pageType"></ng-doc-page-wrapper>`,
  imports: [NgDocPageWrapperComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageWrapperComponent {
    routes = routes[0].children!;
    headerContent = headerContent;
    pageType: NgDocPageType = 'guide';
    hasBreadcrumb = true;
}


const routes: Routes = [{
  path: '',
  component: PageWrapperComponent,
  title: `Installation`,
  children: [
    {
      path: '',
      loadChildren: () => import('./index/page'),
      title: `Automatic (recommended)`,
      data: {
        icon: '',
      }
    },
    {
      path: 'manual',
      loadChildren: () => import('./manual/page'),
      title: `Manual`,
      data: {
        icon: '',
      }
    },
  ]
}]

export default routes;
